/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import React, { FunctionComponent, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { FormField as BronsonReactFormField, ErrorMessage, InfoIcon } from '@vwfs-bronson/bronson-react';
import { Field, FieldInputProps, FormikProps } from 'formik';
import get from 'lodash/get';
import { loadingSelectors } from '../../services/redux/features/loading.slice';

interface ComponentProps {
  render: (props: FieldInputProps<any>) => ReactNode;
  name: string;
  labelElement?: string;
  labelText?: string;
  hint?: string;
  infoText?: string;
  required?: boolean;
  requiredText?: string;
  type: any;
  className?: string;
  disabled?: boolean;
  testId?: string;
  /**
   * Whether to disable input when `loading` property of `custom` state is true.
   */
  disableDuringLoading?: boolean;
}

const getErrorMessage = (fieldTouched: boolean, errors: string, name: string) => {
  return fieldTouched && !!errors ? (
    <ErrorMessage
      id={`error-message-${name}`}
      testId={`error-message-${name}`}
      dangerouslySetInnerHTML={{ __html: errors as string }}
    />
  ) : null;
};

export const FormField: FunctionComponent<ComponentProps> = ({
  render,
  name,
  labelElement,
  labelText,
  hint,
  infoText,
  required = false,
  type,
  className,
  testId,
  disabled = false,
  disableDuringLoading = true,
}) => {
  const isLoading = useSelector(loadingSelectors.selectLoading);

  return (
    <Field name={name} disabled={disabled || (disableDuringLoading && isLoading)}>
      {({ field, form }: { field: FieldInputProps<any>; form: FormikProps<any> }) => (
        <BronsonReactFormField
          className={className}
          labelElement={labelElement || 'label'}
          labelText={labelText}
          type={type || 'input'}
          errorMessage={getErrorMessage(get(form.touched, name) as boolean, get(form.errors, name) as string, name)}
          hint={hint}
          required={required}
          requiredText="*"
          infoIcon={infoText ? <InfoIcon icon="semantic-info">{infoText}</InfoIcon> : null}
          testId={testId}
        >
          {render({
            ...field,
            type,
          } as FieldInputProps<any>)}
        </BronsonReactFormField>
      )}
    </Field>
  );
};
